import React from 'react'
import LoginContainer from './login.container';


const LoginPage = (props)=>{
    return (<LoginContainer {...props}></LoginContainer>)};

export default LoginPage;
